import { render, staticRenderFns } from "./LabelManagement.vue?vue&type=template&id=8418e17e&scoped=true&"
import script from "./LabelManagement.vue?vue&type=script&lang=js&"
export * from "./LabelManagement.vue?vue&type=script&lang=js&"
import style0 from "./LabelManagement.vue?vue&type=style&index=0&id=8418e17e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8418e17e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VColorPicker,VIcon,VMain,VSelect,VTooltip})
